import { Icon } from "./Icon";
import { useT } from "./i18n";

/**
 * The account's role as a small badge (PLAN.md 4.22): a crown for the owner, a custodian helmet for
 * an admin, a robot for a service account that uses the API. Ordinary members show nothing.
 */
export function RoleBadge({ role, kind }: { role: string; kind?: string }) {
  const t = useT();
  const badge =
    role === "owner" ? ({ icon: "crown", label: t.roles.owner, hint: t.roles.ownerHint, tone: "owner" } as const)
    : role === "admin" ? ({ icon: "helmet", label: t.roles.admin, hint: t.roles.adminHint, tone: "admin" } as const)
    : kind === "service" ? ({ icon: "robot", label: t.roles.service, hint: t.roles.serviceHint, tone: "service" } as const)
    : null;
  if (!badge) return null;
  return (
    <span className={`role-badge role-${badge.tone}`} title={badge.hint}>
      <Icon name={badge.icon} size={16} />
      {badge.label}
    </span>
  );
}
